// Regex-based sanitizer for the store's own generated description HTML, previewed via
// dangerouslySetInnerHTML. Not a general-purpose HTML sanitizer — it only strips the
// classic script-injection vectors before the markup is ever set as innerHTML.
const BLOCK_TAGS = /<(script|iframe|object|embed|style)\b[^>]*>[\s\S]*?<\/\1\s*>/gi;
const EVENT_ATTR = /\son\w+\s*=\s*(".*?"|'.*?'|[^\s>]+)/gi;
const JS_URL_ATTR = /\s(href|src)\s*=\s*("javascript:[^"]*"|'javascript:[^']*'|javascript:[^\s>]*)/gi;

export function sanitizeHtml(html: string): string {
  return html.replace(BLOCK_TAGS, "").replace(EVENT_ATTR, "").replace(JS_URL_ATTR, "");
}
